export default AlreadyConnected => {
    return (
        <>
            <div className="text-center">
                <h1 className="text-4xl font-light tracking-tight text-gray-900 sm:text-6xl">Your profile is <strong>already</strong> connected!</h1>
                <p className="mt-6 text-lg leading-8 text-gray-600">Go to the <a href={"/"}>Dashboard</a> to see a summary or to the <a href={'/app/loans'}>Loans</a> menu to see your loans.</p>
            </div>
        </>
    )
}